module.exports = __webpack_public_path__ + "img/preview.d673dd1e.png";